import styled from 'styled-components';
import { FlexColumn } from '../../../styled/common';

export const VipHeaderContainer = styled(FlexColumn)`
  @media (max-width: ${({ theme }) => theme.tabletBreakpoint}) {
    flex-direction: column-reverse;
  }
`;

export const AllVippedLinkContainer = styled.div`
  margin-left: auto;

  @media (max-width: ${({ theme }) => theme.tabletBreakpoint}) {
    display: none;
  }
`;
